import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId", "description", "sideContent", "children", "defaultOpen"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { hasReactChildren } from 'utils/ui';
import { BASIC } from 'styles/spacingPresets';
import Card from 'components/Card';
import Divider from 'components/Divider';
import Flex, { Box } from 'components/Flex';
import Heading from 'components/Heading';
import Text from 'components/Text';
import Disclosure from 'components/Disclosure';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TitleCardWithToggle(_ref) {
  var title = _ref.title,
    titleStringId = _ref.titleId,
    description = _ref.description,
    sideContent = _ref.sideContent,
    children = _ref.children,
    _ref$defaultOpen = _ref.defaultOpen,
    defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var titleId = useUniqueId(titleStringId);
  var hasChildren = hasReactChildren(children);
  return /*#__PURE__*/_jsx(Disclosure.Provider, {
    initialState: defaultOpen,
    children: /*#__PURE__*/_jsxs(Card, _objectSpread(_objectSpread({
      role: "region",
      "aria-labelledby": titleId,
      px: BASIC.LARGE,
      py: BASIC.MEDIUM,
      breakpoints: BASIC.BREAKPOINTS
    }, otherProps), {}, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        wrap: true,
        alignItems: "baseline",
        gap: "xxs",
        children: [/*#__PURE__*/_jsx(Box, {
          grow: true,
          shrink: true,
          children: /*#__PURE__*/_jsxs(Disclosure.Toggle, {
            children: [/*#__PURE__*/_jsx(Heading, {
              as: "h2",
              mr: "auto",
              id: titleId,
              children: title
            }), Boolean(description) && /*#__PURE__*/_jsx(Text, {
              as: "p",
              size: "s",
              mt: "xxs",
              children: description
            })]
          })
        }), Boolean(sideContent) && /*#__PURE__*/_jsx(Box, {
          children: sideContent
        })]
      }), /*#__PURE__*/_jsxs(Disclosure.Hidden, {
        children: [hasChildren && /*#__PURE__*/_jsx(Divider, {
          my: "m"
        }), children]
      })]
    }))
  });
}